import React, { useEffect, useState } from 'react';
import { AiOutlineClose } from 'react-icons/ai';
import ChatCandidate from './chat-Candidate-gpt';
import ChatCandidateSingle from './ChatCandidate-single';
import './Modal.css';


const Modal = ({ isOpen, onClose, destinatario}) => {

    const [postId, setPostId] = useState(''); 
    const [isStreaming, setIsStreaming] = useState(false);
    const handleClose = () => {
      onClose();
    };
  
    if (!isOpen) {
      return null;
    }

  return (
    <>
      
        <div className="modal-wrapper-terminos">
          <div className="modal-content-terminos"><button className="close-button-terminos" onClick={handleClose}>
                <AiOutlineClose />
              </button>
            <div className="modal-header-chat-candidate">
            
            </div>
            <div className="modal-body-terminos-candidate">
            {postId === '' &&(<ChatCandidate destinatario={destinatario} setPostId={setPostId} postId={postId} isStreaming={isStreaming} setIsStreaming={setIsStreaming}/>)}
            {postId !== '' &&(<ChatCandidateSingle destinatario={destinatario} setPostId={setPostId} postId={postId} isStreaming={isStreaming} setIsStreaming={setIsStreaming}/>)}
            </div>
          </div>
        </div>
      
    </>
  );
};

export default Modal;